import {fabric} from 'fabric';
import ProofreadFile from '../../lib/ProofreadFile';
import config from '../../config';

fabric.PRRect = fabric.util.createClass(fabric.Rect, {
	type: 'PRRect',
  originX:'center',
  originY:'center',

  fill: 'transparent',
  stroke: 'red',
  strokeWidth: 4,
  lockRotation:true,
  lockUniScaling:false,
  cornerStrokeColor: 'transparent',
  strokeUniform: true,
  padding: 0,
  noScaleCache: true,

  directionType: 'text',

  photoData: null,
});

fabric.PRRect.prototype.initialize = function(obj, options)
{
	this.callSuper('initialize', obj, options || {});
 
  if (!this.createdTimestamp) {
    this.set({
      createdTimestamp: Date.now(),
    })
  }

  this.drawColor = config.proofread.customerColor;

  if (this.photo) {
    ProofreadFile.getPhoto(this.photo).then(p=>{
      const img = new Image();
      img.onload = () => {
        this.photoData = img;
        if (this.canvas) this.canvas.requestRenderAll();
      }
      img.src = 'data:image/jpeg;base64,'+p.thumbnail;
    }, ()=>{});
  }

  // target key の統一
  if (this.moveTarget) this.targetTimestamp = this.moveTarget;
  else if (this.changeTarget) this.targetTimestamp = this.changeTarget;
  else if (this.changeCharTarget) this.targetTimestamp = this.changeCharTarget;

  this.on('selected', this.onSelected);
  this.on('deselected', this.onDeselected);

  switch (this.directionType) {
    case 'changeChar':
      this.set({
        fill: 'white',
        stroke: 'red',
        strokeWidth: 2,
        minWidth: 34,
        minHeight: 34,
      });
      this.setControlsVisibility({
        bl: true, br: true, mb: false, ml: false, mt: false,
        tl: true, tr: true, mtr:false
      });
      this.off('modified', this.onModified);
      this.on('scaling',           this.onScaling);
      this.on('moving',           this.onMoving);
      break;
    case 'changeCharTarget':
      this.set({
        fill: 'red',
        strokeWidth: 0,
        lockScalingX:true,
        lockScalingY:true,
        directionType: 'changeCharTarget',
        radius: 10,
        width:20,
        height:20,
      });
      this.setControlsVisibility({
        bl:false, br:false, mb:false, ml:false, mt:false, 
        tl:false, tr:false, mtr:false
      });
      break;
    default:
      this.set({
        photo: obj.photo,
        stroke: this.drawColor,
        strokeWidth: this.directionType === 'move'  ? 0.5 : 4,
      });
      this.setControlsVisibility({
        bl: true, br: true, mb: true, ml: true, mt: true,
        tl: true, tr: true, mtr: false
      });
      this.on('modified', this.onModified);
      this.off('scaling',           this.onScaling);
      this.off('moving',           this.onMoving);
  }
}

fabric.PRRect.prototype.onSelected = function(e) {
  this.prevCondition = JSON.parse(JSON.stringify(this));
  this.set({drawColor: 'blue'})

  if (['change','move','changeChar'].indexOf(this.directionType) >= 0) {
    let targetFrame = this.canvas.getObjects('PRRect').find(o=>{
      return o.createdTimestamp === this.targetTimestamp;
    });
    if (targetFrame) targetFrame.drawColor = this.drawColor;
  }
  else if (this.directionType.match(/Target$/)) {
    let parentFrame = this.canvas.getObjects('PRRect').find(o=>{
      return this.createdTimestamp === o.targetTimestamp;
    });
    if (parentFrame) parentFrame.drawColor = this.drawColor;
  }
}
fabric.PRRect.prototype.onDeselected = function(e) {
  this.set({ drawColor: 'red' });

  if (['change','move','changeChar'].indexOf(this.directionType) >= 0) {
    let targetFrame = this.canvas.getObjects('PRRect').find(o=>{
      return o.createdTimestamp === this.targetTimestamp;
    });
    if (targetFrame) targetFrame.drawColor = this.drawColor;
  }
  else if (this.directionType.match(/Target$/)) {
    let parentFrame = this.canvas.getObjects('PRRect').find(o=>{
      return this.createdTimestamp === o.targetTimestamp;
    });
    if (parentFrame) parentFrame.drawColor = this.drawColor;
  }
}
fabric.PRRect.prototype.onMoving = function(e) { // changeCharのみ
  this.prevCondition = JSON.parse(JSON.stringify(this));
}
fabric.PRRect.prototype.onScaling = function(e) { // changeCharのみ
  let nextSize = {}
  if (this.width*this.scaleX < 34) {
    nextSize.width = 34;
    nextSize.scaleX = 1;
    nextSize.left = this.prevCondition.left;
  }
  if (this.height*this.scaleY < 34) {
    nextSize.height = 34;
    nextSize.scaleY = 1;
    nextSize.top = this.prevCondition.top;
  }
  this.set(nextSize);
  this.prevCondition = JSON.parse(JSON.stringify(this));
}

fabric.PRRect.prototype.onModified = function(e) {// changeChar以外
  if (!this.canvas) return;
  let refine = {};
  let minimum = this.canvas.minimumSize;
  let c = this.getPointByOrigin('center', 'center');
  if (this.width  * this.scaleX < minimum) {
    refine.scaleX = minimum/this.width;
    let diffX = (refine.scaleX-this.scaleX)*this.width/2;
    refine.left = c.x + diffX;
  }
  if (this.height * this.scaleY < minimum) {
    refine.scaleY = minimum/this.height;
    let diffY = (refine.scaleY-this.scaleY)*this.height/2;
    refine.top  = c.y + diffY;
  }
  if (Object.keys(refine).length > 0) this.set(refine);
}



// @override render
fabric.PRRect.prototype.render = function(ctx) {

  //ctx.globalAlpha = this.opacity;
  if (!this.visible) return;
  //if (this.directionType == "changeTarget") return;

  let zoomValue = this.canvas.getZoom();

  let strokeWidth = this.strokeWidth;
  this.set({strokeWidth: this.strokeWidth / zoomValue});
  
  let sw = this.width*this.scaleX;
  let sh = this.height*this.scaleY;
  let tl = new fabric.Point(this.left-sw/2, this.top-sh/2);
  let br = new fabric.Point(this.left+sw/2, this.top+sh/2);

  if (this.directionType === "change") {
    this.drawFrame(ctx, strokeWidth, tl);
    let targetFrame = this.canvas.getObjects('PRRect').find(o=>{
      return o.createdTimestamp === this.targetTimestamp;
    });
    if (targetFrame) {

      let targetCenter = targetFrame.getPointByOrigin('center', 'center');
      let center = this.getPointByOrigin('center', 'center');
      let distance = getDistance(targetCenter, center);
      ctx.save();
      ctx.translate(targetCenter.x, targetCenter.y);
      let radian = getRadian(targetCenter, center);
      ctx.rotate(radian);
      ctx.strokeStyle = this.drawColor;
      let lineWidth = 40/3*Math.sqrt(2);
      ctx.lineWidth = lineWidth;
      ctx.beginPath();
      ctx.moveTo(40,0)
      ctx.lineTo(distance-40, 0);
      ctx.stroke();

      // 入替文字
      ctx.fillStyle = '#fff';
      ctx.font = "bold 14px sans-serif";
      let text = "入替";
      let metrics = ctx.measureText(text);
      let textHeight = metrics.actualBoundingBoxAscent+metrics.actualBoundingBoxDescent;
      if (Math.abs(radian/Math.PI*180) > 90) {
        ctx.save();
        ctx.translate(distance/2, lineWidth/2);
        ctx.rotate(180*Math.PI/180);
        let y = lineWidth - textHeight/4;
        ctx.fillText(text, -metrics.width/2, y);
        ctx.restore();
      }
      else {
        ctx.fillText(text, distance/2-metrics.width/2, textHeight/2);
      }


      // 始点の矢印
      ctx.save();
      ctx.fillStyle = this.drawColor;
      ctx.rotate(Math.PI / 180 * -45);
      drawArrow(ctx, 40);
      ctx.restore();

      ctx.restore();
      
      // 終点の矢印
      ctx.save();
      
      ctx.fillStyle = this.drawColor;
      ctx.translate(center.x, center.y);
      ctx.rotate(getRadian(targetCenter, center) + Math.PI / 180 * 135);
      //ctx.rotate(Math.PI / 180 * 135);
      drawArrow(ctx, 40);
      
      ctx.restore();


      function getRadian(p1, p2) {
        return Math.atan2(p2.y - p1.y, p2.x - p1.x);
      }
      function getDistance(p1, p2) {
        return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
      }
      function drawArrow(ctx, v) {
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(0, v);
        ctx.lineTo(v/3, v/3*2);
        ctx.lineTo(v*2/3, v);
        ctx.lineTo(v, v/3*2);
        ctx.lineTo(v/3*2, v/3);
        ctx.lineTo(v, 0);
        ctx.closePath();
        ctx.fill();
      }
    }
  } // end change
  else if (this.directionType === "move") {
    this.drawFrame(ctx, strokeWidth, tl);
    let targetFrame = this.canvas.getObjects('PRRect').find(o=>{
      return o.createdTimestamp === this.targetTimestamp;
    });
    if (targetFrame) {
      
      let targetCenter = targetFrame.getPointByOrigin('center', 'center');
      let center = this.getPointByOrigin('center', 'center');
      let distance = getDistance(targetCenter, center);
      ctx.save();
      ctx.translate(targetCenter.x, targetCenter.y);
      let radian = getRadian(targetCenter, center);
      ctx.rotate(radian);
      ctx.strokeStyle = this.drawColor;
      let lineWidth = 40/3*Math.sqrt(2);
      ctx.lineWidth = lineWidth;
      ctx.beginPath();
      ctx.moveTo(40,0)
      ctx.lineTo(distance-40, 0);
      ctx.stroke();

      // 「移動」文字
      ctx.fillStyle = '#fff';
      ctx.font = "bold 14px sans-serif";
      let text = "移動";
      let metrics = ctx.measureText(text);
      let textHeight = metrics.actualBoundingBoxAscent+metrics.actualBoundingBoxDescent;
      if (Math.abs(radian/Math.PI*180) > 90) {
        ctx.save();
        ctx.translate(distance/2, lineWidth/2);
        ctx.rotate(180*Math.PI/180);
        let y = lineWidth - textHeight/4;
        ctx.fillText(text, -metrics.width/2, y);
        ctx.restore();
      }
      else {
        ctx.fillText(text, distance/2-metrics.width/2, textHeight/2);
      }


      // 始点の矢印
      ctx.save();
      ctx.fillStyle = this.drawColor;
      ctx.rotate(Math.PI / 180 * -45);
      drawArrow(ctx, 40);
      ctx.restore();

      ctx.restore();

      function getRadian(p1, p2) {
        return Math.atan2(p2.y - p1.y, p2.x - p1.x);
      }
      function getDistance(p1, p2) {
        return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
      }
      function drawArrow(ctx, v) {
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(0, v);
        ctx.lineTo(v/3, v/3*2);
        ctx.lineTo(v*2/3, v);
        ctx.lineTo(v, v/3*2);
        ctx.lineTo(v/3*2, v/3);
        ctx.lineTo(v, 0);
        ctx.closePath();
        ctx.fill();
      }
    }
  } // end move
  else if (this.directionType.match(/Photo$/)) {
    if (this.photo && this.photoData) {
      let w = this.width*this.scaleX;
      let h = this.height*this.scaleY  - 20/*上部の表示分*/;

      let magnify = Math.max(w / this.photoData.width, h / this.photoData.height);
      
      let left = (this.photoData.width - w/magnify) / 2;
      let top = (this.photoData.height - h/magnify) / 2;

      ctx.save();
      ctx.translate(tl.x, tl.y);
      ctx.drawImage(this.photoData, left, top, w/magnify , h/magnify, 0, 20/*上部の表示分*/, w, h);
      ctx.restore();

      // 画像ファイル名
      let filename = this.photo.replace(/_[^_]+(\.[^.]+)$/, '$1');

      // 上に表示
      ctx.save();
      ctx.strokeStyle = this.drawColor;
      ctx.fillStyle = '#fff';
      ctx.lineWidth = this.strokeWidth / 2;
      ctx.translate(tl.x, tl.y);
      ctx.rect(20, 0, this.width*this.scaleX-20, 20);
      ctx.fill(); 
      ctx.fillStyle = this.drawColor;
      ctx.font = "bold 14px sans-serif";
      let metrics = ctx.measureText(filename);
      let textHeight = metrics.actualBoundingBoxAscent;
      let y = (20-textHeight)/2+textHeight;
      ctx.fillText(filename, 22, y, this.width*this.scaleX-26);
      ctx.restore();


      /*
      // 下の場合
      ctx.save();
      ctx.strokeStyle = "red";
      ctx.fillStyle = '#fff';
      ctx.lineWidth = this.strokeWidth / 2;
      ctx.translate(tl.x, tl.y+this.height*this.scaleY);
      ctx.beginPath();
      ctx.rect(0, -20, this.width*this.scaleX, 20);
      ctx.fill(); 
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(32, -20);
      ctx.lineTo(32, 0);
      ctx.stroke();

      ctx.fillStyle = 'red';
      ctx.rect(0, -20, 32, 20);
      ctx.fill();
      ctx.fillStyle = '#fff';
      ctx.font = "bold 14px sans-serif";
      ctx.fillText("差替", 3, -6);

      ctx.fillStyle = 'red';
      ctx.fillText(filename, 34, -6, this.width*this.scaleX-38);
      ctx.restore();
      */

    }
  } // end photo
  else if (this.directionType === "triming") {
    let v = 40;
    ctx.fillStyle = this.drawColor;
    // 左上
    ctx.save();
    let tltl = tl.subtract((new fabric.Point(v, v)));
    ctx.translate(tltl.x, tltl.y);
    drawArrow(ctx, v);
    ctx.restore();
    // 左下
    let tlbl = new fabric.Point(tl.x-v, br.y+v);
    ctx.save();
    ctx.translate(tlbl.x, tlbl.y);
    ctx.rotate(Math.PI / -2);
    drawArrow(ctx, v);
    ctx.restore();
    // 右上
    let trtr = new fabric.Point(br.x+v, tl.y-v);
    ctx.save();
    ctx.translate(trtr.x, trtr.y);
    ctx.rotate(Math.PI / 2);
    drawArrow(ctx, v);
    ctx.restore();
    // 右下
    let brbr = br.add((new fabric.Point(v, v)));
    ctx.save();
    ctx.translate(brbr.x, brbr.y);
    ctx.rotate(Math.PI);
    drawArrow(ctx, v);
    ctx.restore();

    function drawArrow(ctx, v) {
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(0, v);
      ctx.lineTo(v/3, v/3*2);
      ctx.lineTo(v*2/3, v);
      ctx.lineTo(v, v/3*2);
      ctx.lineTo(v/3*2, v/3);
      ctx.lineTo(v, 0);
      ctx.closePath();
      ctx.fill();
    }
  } // end trimming
  else if (this.directionType === "delete") {
    ctx.save();
    ctx.strokeStyle = this.drawColor;
    ctx.lineWidth = 4 / zoomValue;
    ctx.beginPath();
    ctx.moveTo(tl.x, tl.y);
    ctx.lineTo(br.x, br.y);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(br.x, tl.y);
    ctx.lineTo(tl.x, br.y);
    ctx.stroke();
    ctx.restore();
  } // end delete
  else if (this.directionType === 'keep') {
    ctx.save();
    ctx.strokeStyle = '#fff';
    ctx.fillStyle = this.drawColor;
    ctx.font = "bold 44px sans-serif";
    let metrics = ctx.measureText('OK');
    let textHeight = metrics.actualBoundingBoxAscent;
    let x = tl.x+(br.x-tl.x)/2-metrics.width/2;
    let y = tl.y+(br.y-tl.y)/2+textHeight/2;
    ctx.lineWidth = "12";
    ctx.lineJoin = "miter";
    ctx.miterLimit = "5"
    ctx.strokeText("OK", x, y);
    ctx.fillText('OK', x, y);
    ctx.restore();
  } // end keep
  else if (this.directionType === 'changeChar') {
    let targetPoint = this.canvas.getObjects('PRRect').find(o=>{
      return o.createdTimestamp === this.targetTimestamp;
    });
    if (targetPoint) {
      let targetCenter = targetPoint.getPointByOrigin('center', 'center');
      let center = this.getPointByOrigin('center', 'center');
      let distance = getDistance(targetCenter, center);
      ctx.save();
      ctx.strokeStyle = this.drawColor;
      ctx.translate(targetCenter.x, targetCenter.y);
      let radian = getRadian(targetCenter, center);
      ctx.rotate(radian);
      let lineWidth = 10/3*Math.sqrt(2);
      ctx.lineWidth = lineWidth;
      ctx.beginPath();
      ctx.moveTo(0,0)
      ctx.lineTo(distance, 0);
      ctx.stroke();
      ctx.restore();
    }
    function getRadian(p1, p2) {
      return Math.atan2(p2.y - p1.y, p2.x - p1.x);
    }
    function getDistance(p1, p2) {
      return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
    }
    
    this.drawFrame(ctx, this.strokeWidth, tl, '#fff');
  } // end changeChar
  else if (this.directionType === 'changeCharTarget') {
    ctx.fillStyle = this.drawColor;
    ctx.lineWidth = 0;
    
    ctx.beginPath();
    ctx.arc(this.left, this.top, this.radius, 0, 360);
    ctx.closePath();
    ctx.fill();
  }

  let textOverflow = false;
  // ラベル
  if (this.title && this.directionType !== 'keep') {
    let wh = br.subtract(tl);
    let margin = this.directionType==='changeChar' ? 14 : 80;
    let maxWidth = this.directionType==='changeChar' ? wh.x-margin : wh.x-40;

    ctx.save();
    ctx.font = "bold 20px sans-serif";
    let metrics = ctx.measureText(this.title);
    let textHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
    let center = tl.add(new fabric.Point(wh.x/2, wh.y/2));

    if (maxWidth < metrics.width) {
      // 一文字ごとに文字サイズを計算
      let chars = this.title.split("").map(ch=> {
        let metrics = ctx.measureText(ch);
        return {
          ch: ch,
          width: metrics.width
        };
      });
      let lines = chars.reduce((carry, c) => {
        if (carry[carry.length-1].text.length === 0 || carry[carry.length-1].width + c.width < maxWidth) {
          carry[carry.length-1].width += c.width;
          carry[carry.length-1].text += c.ch;
        }
        else {
          carry.push({ width:c.width, text:c.ch });
        }
        return carry;
      }, [{ width:0, text:"" }]);
      
      let lineMargin = 2;
      let w = lines[0].width;
      let h = textHeight*lines.length+lineMargin*(lines.length-1);
      let maxHeight = this.height*this.scaleY-margin;
      if (maxHeight < textHeight) {
        lines = [];
        textOverflow = true;
      }
      else if (h > maxHeight) {
        let innerLineLength = Math.floor((maxHeight - textHeight) / (textHeight + lineMargin)) + 1;
        lines = lines.slice(0, innerLineLength);
        h = textHeight*lines.length+lineMargin*(lines.length-1);
        textOverflow = true;
      }

      if (lines.length > 0) {
        if (this.directionType === 'changeChar') {
          ctx.fillStyle = 'black';
        }
        else {
          ctx.fillStyle = "rgba(255, 255, 255, 0.7)";
          ctx.fillRect(center.x-w/2-10, center.y-h/2-10, w+20,h+20);
          ctx.fillStyle = this.drawColor;
        }
        ctx.font = "20px sans-serif";
        lines.forEach((line, idx)=> {
          let y = center.y-h/2 + (idx*textHeight) + metrics.actualBoundingBoxAscent + (idx*lineMargin);
          ctx.fillText(line.text, center.x-w/2, y);
        })
      }

    }
    else {
      if (this.directionType === 'changeChar') {
        ctx.fillStyle = 'black';
      }
      else {
        ctx.fillStyle = "rgba(255, 255, 255, 0.7)";
        ctx.fillRect(center.x-metrics.width/2-10, center.y-textHeight/2-10, metrics.width+20,textHeight+20);
        ctx.fillStyle = this.drawColor;
      }
      ctx.font = "20px sans-serif";
      ctx.fillText(this.title, center.x-metrics.width/2, center.y+metrics.actualBoundingBoxAscent/2);
    }
    ctx.restore();
  }

  if (['change','move','changeChar','changeCharTarget'].indexOf(this.directionType) < 0) {
    this.drawFrame(ctx, strokeWidth, tl);
  }


  // 番号
  if (!this.directionType.match(/Target$/)) {
    let size = 20;
    let timestamps = this.canvas.getObjects().filter(o=>['PRRect'].indexOf(o.type)>=0)
                  .filter(o=>!o.directionType.match(/Target$/))
                  .map(o=>o.createdTimestamp)
                  .sort((t1,t2)=>{return t1 < t2 ? -1 : 1});
    let num = timestamps.indexOf(this.createdTimestamp) + 1;

    ctx.save();
    ctx.beginPath();
    ctx.translate(tl.x, tl.y);
    ctx.fillStyle = this.drawColor;
    ctx.fillRect(0, 0, size, size);
    ctx.fillStyle = "#fff";
    ctx.font = "bold "+(size*0.8)+"px sans-serif";
    let metrics = ctx.measureText(num);
    let textHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
    let left = (size > metrics.width ? (size-(metrics.width))/2 : 0) -1;
    if (num >= 10) {
      ctx.letterSpacing = '-3px';
    }
    ctx.fillText(num, left, (size-(textHeight))/2+textHeight-1, size);
    ctx.restore();

  }

  if (textOverflow && this.directionType === 'changeChar') {
    ctx.save();
    ctx.strokeStyle = 'red';
    ctx.fillStyle = "#fff";
    ctx.lineWidth = 1;
    ctx.rect(br.x-10, br.y-28, 20, 20);
    ctx.fill();
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(br.x, br.y-23);
    ctx.lineTo(br.x, br.y-13);
    ctx.moveTo(br.x-5, br.y-18);
    ctx.lineTo(br.x+5, br.y-18);
    ctx.stroke();
    ctx.restore();
  }

  this.set({strokeWidth: strokeWidth});


}  // render
fabric.PRRect.prototype.drawFrame = function (ctx, strokeWidth, tl, fillStyle) {
  // 枠線
  ctx.save();
  ctx.strokeStyle = this.drawColor;
  ctx.translate(tl.x, tl.y);
  if (fillStyle) {
    ctx.fillStyle = fillStyle;
    ctx.fillRect(0, 0, this.width*this.scaleX, this.height*this.scaleY)
  }
  ctx.lineWidth = strokeWidth;
  ctx.strokeRect(0, 0, this.width*this.scaleX, this.height*this.scaleY);
  ctx.restore();
}


fabric.PRRect.prototype.setDirectionType = function(type) {
  let next = { directionType: type }

  if (['change','move','changeChar'].indexOf(this.directionType)>=0) {
    let targetFrame = this.canvas.getObjects('PRRect').find(o=>{
      return o.createdTimestamp === this.targetTimestamp;
    });
    if (targetFrame) {
      this.canvas.remove(targetFrame);
    }
  }

  if (type === 'move') {
    next.strokeWidth = 0.5;
  }
  else {
    next.strokeWidth = 4;
  }
  this.set(next);
}

fabric.PRRect.prototype.setPhoto = function(img_name) {
  //this.setDirectionType('photo');
  if (this.photo !== img_name) {
    this.photoData = null;
    ProofreadFile.getPhoto(img_name).then(p=>{
      const img = new Image();
      img.onload = () => {
        this.photoData = img;
        this.canvas.requestRenderAll();
      }
      img.src = 'data:image/jpeg;base64,'+p.thumbnail;
    }, ()=>{})
    this.set({ photo: img_name });
  }
}

fabric.PRRect.prototype.toObject = function() {
  let option = {
    directionType: this.directionType,
    createdTimestamp: this.createdTimestamp, // ユニーク値
    targetTimestamp: this.targetTimestamp,
    title: this.title,
    text: this.text,
    photo: this.photo,

    creator: this.creator,
  };
	let obj =  fabric.util.object.extend(this.callSuper('toObject'), option);
  
  let propNames = Object.keys(option).concat(['type','left','top','width','height','scaleX','scaleY']);
  let slimObj = {};
	Object.keys(obj).forEach( function(key) {
		if (propNames.indexOf(key) >= 0) slimObj[key] = obj[key];
	});

  return slimObj;
}

fabric.PRRect.fromObject = function(obj, callback) {
  callback(new fabric.PRRect(obj));
}

export default fabric.PRRect;